import React, {useEffect, useState} from "react"
import PanelMainInner from "../../PanelMainInner";
import {IRouteParams} from "../../../contracts/router";
import {useParams} from "react-router-dom";
import {ISectionPageComponent} from "../../../contracts/pages";
import ListUsers from "./ListUsers";
import MyModal from "../../Elements/MyModal";
import CreateUserForm from "../../../forms/dashboard/user/CreateUserForm";
import {INewUserData} from "../../../contracts/data/user";
import ProfileUser from "./ProfileUser";
import UserTickets from "./UserTickets";
import UserComments from "./UserComments";
import UserBasket from "./UserBasket";
import UserPurchases from "./UserPurchases";
import UserVideoProduct from "./UserVideoProduct";
import UserWallet from "./UserWallet";
import UserFavorite from "./UserFavorite";
import UserRate from "./UserRate";
import UserLike from "./UserLike";

const UsersSections:React.FC = () => {
    const params:IRouteParams = useParams();
    const [type, setType] = useState<string>("list")
    const [showCreateModal, setShowCreateModal] = useState<boolean>(false)

    const sectionPageComponent:ISectionPageComponent = {
        "list": <ListUsers />,
        "profile": <ProfileUser />,
        "tickets": <UserTickets />,
        "comments": <UserComments />,
        "basket": <UserBasket />,
        "purchases": <UserPurchases />,
        "videos-products": <UserVideoProduct />,
        "wallet": <UserWallet />,
        "favorites": <UserFavorite />,
        "rates": <UserRate />,
        "likes": <UserLike />,
    }

    const handleChangeSuccess = (data: INewUserData) => {
        setShowCreateModal(false)
        window.location.reload()
    }

    useEffect(() => {
        setType(params.type!)
    }, [params.type])

    return(
        <PanelMainInner title={"کاربران"} isBtnAction={type === 'list'} isBg={true} btnActionTxt={"کاربر جدید"} handlerBtnAction={() => setShowCreateModal(true)}>
            <MyModal title={"کاربر جدید"} isOpen={showCreateModal} handlerSecondaryButton={() => setShowCreateModal(false)} btnSecondaryTxt={"بیخیال!"}>
                <CreateUserForm handleChangeSuccess={handleChangeSuccess} />
            </MyModal>
            {sectionPageComponent[type]}
        </PanelMainInner>
    )
}

export default UsersSections